import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import MagicSection from "./components/MagicSection";
import GuaranteesSection from "./components/GuaranteesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CitiesSection from "./components/CitiesSection";
import FAQSection from "./components/FAQSection";
import SeoContentSection from "./components/SeoContentSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import UrgencyBanner from "./components/UrgencyBanner";

// Pages SEO
import RecupererSonEx from "./pages/RecupererSonEx";
import FaireRevenirSonEx from "./pages/FaireRevenirSonEx";
import RetourAffectif from "./pages/RetourAffectif";
import MaraboutFrance from "./pages/MaraboutFrance";
import MaraboutBelgique from "./pages/MaraboutBelgique";
import MaraboutSuisse from "./pages/MaraboutSuisse";
import MaraboutCanada from "./pages/MaraboutCanada";

const Home = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <WhyChooseSection />
        <ServicesSection />
        <HowItWorksSection />
        <MagicSection />
        <GuaranteesSection />
        <TestimonialsSection />
        <CitiesSection />
        <FAQSection />
        <SeoContentSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <UrgencyBanner />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster 
          position="top-center" 
          richColors 
          toastOptions={{
            style: {
              background: '#1f1f1f',
              border: '1px solid rgba(212, 175, 55, 0.3)',
              color: '#fff'
            }
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Pages SEO mots-clés */}
          <Route path="/recuperer-son-ex" element={<RecupererSonEx />} />
          <Route path="/faire-revenir-son-ex" element={<FaireRevenirSonEx />} />
          <Route path="/retour-affectif" element={<RetourAffectif />} />
          {/* Pages SEO pays */}
          <Route path="/marabout-france" element={<MaraboutFrance />} />
          <Route path="/marabout-belgique" element={<MaraboutBelgique />} />
          <Route path="/marabout-suisse" element={<MaraboutSuisse />} />
          <Route path="/marabout-canada" element={<MaraboutCanada />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
